// Bundle Configuration
const BUNDLE_CONFIG = {
  products: [
    {
      id: '7844064362675',
      handle: 'lipo-berberine-powdered-liposomal-berberine-90-capsules',
      title: 'Berberine (Liposomal)',
      price: 75.95,
      image: 'https://renuebyscience.com/cdn/shop/files/RENUE-LIPO-Berberine-1_070df7a8-86d1-41cf-93ff-871fd5b61dcc.png?v=1745950596&width=990'
    },
    {
      id: '7844065968307',
      handle: 'lipo-caakg-powdered-liposomal-90-x-300-mg', 
      title: 'CaAKG (Liposomal)',
      price: 74.95,
      image: 'https://renuebyscience.com/cdn/shop/files/RENUE-LIPO-CaAKG-1_afcc803b-0f39-47ab-85ae-b6cfa504b8f7.png?v=1745950543&width=990'
    },
    {
      id: '7844074094771',
      handle: 'lipo-green-tea-liposomal-green-tea-extract-capsules',
      title: 'LIPO EGCG Green Tea', 
      price: 68.95,
      image: 'https://renuebyscience.com/cdn/shop/files/RENUE-LIPO-EGCG-GreenTea-1.png'
    }
  ],
  discountCode: 'MetStack',
  discountText: 'Save 15% off when you buy all 3!'
};

class BundleCartDrawer {
  constructor() {
    this.cartData = null;
    this.isProcessing = false; // Prevent multiple simultaneous operations
    this.bundleState = 'none'; // Track current state: 'none', 'partial', 'complete'
    this.init();
  }

  init() {
    this.bindEvents();
    this.checkCartOnLoad();
  }

  bindEvents() {
    // Basic cart update events
    document.addEventListener('cart:updated', () => {
      console.log('Cart updated event');
      if (!this.isProcessing) {
        // Wait longer for Shopify to finish updating the drawer
        setTimeout(() => this.checkForBundleProducts(), 2000); // Increased to 2 seconds
      }
    });  

    // Listen for any clicks that might affect cart
    document.addEventListener('click', (e) => {
      // Add to cart
      if (e.target.matches('[data-add-to-cart], [name="add"], .btn--add-to-cart')) {
        console.log('Add to cart clicked');
        if (!this.isProcessing) {
          // Much longer delay to wait for cart drawer to fully update
          setTimeout(() => this.checkForBundleProducts(), 3000); // Increased to 3 seconds
        }
      }
      
      // Remove from cart - Updated to catch your specific remove button structure
      if (e.target.matches('.cart-item__remove a, cart-remove-button a, [href*="/cart/change"]')) {
        console.log('🗑️ Remove button clicked:', e.target);
        if (!this.isProcessing) {
          setTimeout(() => {
            console.log('🔄 Handling product removal...');
            this.handleProductRemoval();
          }, 1000);
        }
      }
      
      // Also catch clicks on the cart-remove-button element itself
      if (e.target.closest('cart-remove-button') || e.target.closest('.cart-item__remove')) {
        console.log('🗑️ Remove area clicked');
        if (!this.isProcessing) {
          setTimeout(() => {
            console.log('🔄 Handling product removal...');
            this.handleProductRemoval();
          }, 1000);
        }
      }
    });

    // ADD THIS: Listen for when cart drawer finishes updating
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && 
            mutation.target.id === 'CartDrawer' || 
            mutation.target.classList.contains('cart-drawer')) {
          console.log('🔄 Cart drawer DOM changed, checking for bundle...');
          if (!this.isProcessing) {
            setTimeout(() => this.checkForBundleProducts(), 500);
          }
        }
      });
    });

    // Watch for changes to the cart drawer
    const cartDrawer = document.getElementById('CartDrawer');
    if (cartDrawer) {
      observer.observe(cartDrawer, { 
        childList: true, 
        subtree: true 
      });
    }

    // Listen for quantity changes (minus button, input changes)
    document.addEventListener('change', (e) => {
      if (e.target.matches('input[name*="updates"], .quantity__input, [data-quantity-input]')) {
        console.log('📊 Quantity changed');
        if (!this.isProcessing) {
          setTimeout(() => this.handleProductRemoval(), 1000);
        }
      }
    });

    // Listen for form submissions (cart updates)
    document.addEventListener('submit', (e) => {
      if (e.target.matches('form[action*="/cart"]')) {
        console.log('📝 Cart form submitted');
        if (!this.isProcessing) {
          setTimeout(() => this.handleProductRemoval(), 1000);
        }
      }
    });
  }

  async handleProductRemoval() {
    if (this.isProcessing) return;
    this.isProcessing = true;
    
    console.log('🔄 Handling product removal and checking bundle status...');
    
    // Fetch updated cart data
    await this.fetchCartData();
    
    // Check current bundle status
    const bundleProductsInCart = this.getBundleProductsInCart();
    
    console.log(`Bundle products in cart: ${bundleProductsInCart.length}/3`);
    console.log(`Previous bundle state: ${this.bundleState}`);
    
    if (bundleProductsInCart.length === 3) {
      // Still have all 3 products, keep discount
      console.log('✅ Bundle still complete, keeping discount');
      if (this.bundleState !== 'complete') {
        this.bundleState = 'complete';
        this.checkForBundleProducts();
      }
    } else {
      // Bundle is incomplete or broken - ONLY remove discount if we previously had it
      if (this.bundleState === 'complete') {
        console.log('⚠️ Bundle was complete but now broken - removing discount');
        await this.removeDiscountFromCart();
      } else {
        console.log('⚠️ Bundle incomplete but no discount to remove');
      }
      
      if (bundleProductsInCart.length > 0 && bundleProductsInCart.length < 3) {
        // Have 1-2 products, show bundle banner
        console.log('📢 Showing bundle completion banner');
        this.bundleState = 'partial';
        
        // DIRECTLY call showBundleBanner instead of checkForBundleProducts
        const missingProducts = this.getMissingBundleProducts(bundleProductsInCart);
        this.showBundleBanner(bundleProductsInCart.length, missingProducts);
        
      } else {
        // No bundle products, hide everything
        console.log('🧹 No bundle products, cleaning up displays');
        this.bundleState = 'none';
        this.cleanupBundleDisplays();
      }
    }
    
    this.isProcessing = false;
  }

  async removeDiscountFromCart() {
    try {
      console.log('🗑️ Removing discount code from cart...');
      
      // Method 1: Remove discount using empty string (official Shopify way)
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          discount: '' // Empty string removes all discounts
        })
      });
      
      // Method 2: Also clear cart attributes
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: { 
            'discount_code': null,
            '_discount': null,
            'promo_code': null,
            'bundle_discount_applied': null
          }
        })
      });
      
      console.log('✅ Discount removal completed');
      
    } catch (error) {
      console.error('❌ Error removing discount:', error);
    }
  }

  async checkCartOnLoad() {
    await this.fetchCartData();
    this.checkForBundleProducts();
  }

  async fetchCartData() {
    try {
      const response = await fetch('/cart.js');
      this.cartData = await response.json();
      console.log('Cart data fetched:', this.cartData);
    } catch (error) {
      console.error('Error fetching cart data:', error);
    }
  }

  async checkForBundleProducts() {
    if (this.isProcessing) return;
    
    console.log('Checking for bundle products...');
    await this.fetchCartData();
    
    if (!this.cartData || !this.cartData.items) {
      console.log('No cart data available');
      return;
    }

    // Get bundle products currently in cart
    const bundleProductsInCart = this.getBundleProductsInCart();
    console.log(`Bundle products in cart: ${bundleProductsInCart.length}/3`);
    
    const newState = bundleProductsInCart.length === 3 ? 'complete' : 
                     bundleProductsInCart.length > 0 ? 'partial' : 'none';
    
    // Only update if state actually changed
    if (this.bundleState === newState) {
      console.log(`Bundle state unchanged: ${newState}`);
      return;
    }
    
    this.bundleState = newState;

    // Clean up any existing displays first
    this.cleanupBundleDisplays();
    
    if (bundleProductsInCart.length === 3) {
      // All 3 products - apply discount
      console.log('✅ Bundle complete - applying discount');
      await this.applyBundleDiscount();
    } else if (bundleProductsInCart.length > 0 && bundleProductsInCart.length < 3) {
      // 1-2 products - show bundle offer
      console.log('⚠️ Partial bundle - showing offer');
      const missingProducts = this.getMissingBundleProducts(bundleProductsInCart);
      this.showBundleBanner(bundleProductsInCart.length, missingProducts);
    } else {
      // No bundle products - hide everything
      console.log('❌ No bundle products - hiding displays');
    }
  }

  getBundleProductsInCart() {
    const bundleProductIds = BUNDLE_CONFIG.products.map(p => p.id);
    return this.cartData.items.filter(item => 
      bundleProductIds.includes(item.product_id.toString())
    );
  }

  getMissingBundleProducts(productsInCart) {
    const cartProductIds = productsInCart.map(item => item.product_id.toString());
    return BUNDLE_CONFIG.products.filter(product => 
      !cartProductIds.includes(product.id)
    );
  }

  cleanupBundleDisplays() {
    // Remove all bundle-related displays
    const bundleBanner = document.querySelector('[data-bundle-banner]');
    const bundleSuccess = document.querySelector('[data-bundle-success]');
    const discountLine = document.querySelector('.totals__discount-line');
    const finalTotals = document.querySelector('.totals__final');
    
    if (bundleBanner) bundleBanner.remove();
    if (bundleSuccess) bundleSuccess.remove();
    if (discountLine) discountLine.remove();
    if (finalTotals) finalTotals.remove();

    // Reset original total display
    const totalValueElement = document.querySelector('.totals__total-value');
    if (totalValueElement && this.cartData) {
      totalValueElement.innerHTML = `${(this.cartData.total_price / 100).toFixed(2)} USD`;
      totalValueElement.style.textDecoration = 'none';
      totalValueElement.style.color = '';
    }
  }

  showBundleBanner(currentCount, missingProducts) {
    console.log('🎯 showBundleBanner() STARTED');
    console.log('📊 Parameters:', currentCount, missingProducts);
    
    const remainingCount = 3 - currentCount;
    const totalPrice = missingProducts.reduce((sum, product) => sum + product.price, 0);
  
    const bannerHtml = `
      <div class="bundle-banner" data-bundle-banner>
        <div class="bundle-banner__content">
          <div class="bundle-banner__header">
            <h3>Complete Your Bundle!</h3>
            <p>You have ${currentCount} of 3 items. Add ${remainingCount} more to unlock your discount!</p>
          </div>
          
          <div class="bundle-banner__products">
            ${missingProducts.map(product => `
              <div class="bundle-missing-product">
                <img src="${product.image}" alt="${product.title}">
                <span>${product.title}</span>
                <span class="price">$${product.price.toFixed(2)}</span>
              </div>
            `).join('')}
          </div>
          
          <div class="bundle-banner__action">
            <button class="bundle-complete-button" data-missing-products='${JSON.stringify(missingProducts)}'>
              Add ${remainingCount} Product${remainingCount > 1 ? 's' : ''} + Get ${BUNDLE_CONFIG.discountCode} Discount 
              <span class="bundle-total">($${totalPrice.toFixed(2)})</span>
            </button>
          </div>
          
          <div class="bundle-banner__discount">
            <small>${BUNDLE_CONFIG.discountText}</small>
          </div>
        </div>
      </div>
    `;
  
    console.log('🏗️ Banner HTML created:', bannerHtml.substring(0, 100) + '...');
  
    // Find cart drawer and insert banner
    const cartDrawer = this.findCartDrawer();
    console.log('📦 Cart drawer found:', !!cartDrawer);
    console.log('📦 Cart drawer element:', cartDrawer);
    
    if (cartDrawer) {
      // Check if banner already exists
      const existingBanner = cartDrawer.querySelector('[data-bundle-banner]');
      console.log('🏷️ Existing banner found:', !!existingBanner);
      
      if (existingBanner) {
        console.log('🗑️ Removing existing banner');
        existingBanner.remove();
      }
      
      const cartItems = cartDrawer.querySelector('.cart-items, [data-cart-items], .cart__items');
      console.log('📦 Cart items container found:', !!cartItems);
      console.log('📦 Cart items element:', cartItems);
      
      if (cartItems) {
        console.log('✅ Inserting banner after cart items');
        cartItems.insertAdjacentHTML('afterend', bannerHtml);
      } else {
        console.log('⚠️ No cart items found, inserting at beginning of drawer');
        cartDrawer.insertAdjacentHTML('afterbegin', bannerHtml);
      }
      
      // Verify the banner was actually inserted
      const insertedBanner = cartDrawer.querySelector('[data-bundle-banner]');
      console.log('✅ Banner successfully inserted:', !!insertedBanner);
      console.log('🎯 Inserted banner element:', insertedBanner);
      
      if (insertedBanner) {
        console.log('🎉 Banner is visible:', insertedBanner.offsetHeight > 0);
        console.log('🎉 Banner parent:', insertedBanner.parentElement);
        this.bindBannerEvents();
      } else {
        console.error('❌ Banner insertion failed - not found in DOM after insertion!');
      }
      
    } else {
      console.error('❌ Cart drawer not found!');
    }
    
    console.log('🏁 showBundleBanner() COMPLETED');
  }

  findCartDrawer() {
    const selectors = [
      '.cart-drawer',
      '[data-cart-drawer]',
      '.drawer__inner',
      '.cart-drawer__inner',
      '.mini-cart',
      '.cart-sidebar',
      '.drawer-cart',
      '#cart-drawer'
    ];

    for (const selector of selectors) {
      const element = document.querySelector(selector);
      if (element) return element;
    }

    console.warn('Cart drawer not found');
    return null;
  }

  bindBannerEvents() {
    const button = document.querySelector('.bundle-complete-button');
    if (button) {
      button.addEventListener('click', async (e) => {
        e.preventDefault();
        
        const missingProducts = JSON.parse(e.target.dataset.missingProducts);
        await this.addMissingProductsToBundle(missingProducts);
      });
    }
  }

  async addMissingProductsToBundle(missingProducts) {
    if (this.isProcessing) return;
    this.isProcessing = true;
    
    const button = document.querySelector('.bundle-complete-button');
    const originalText = button.textContent;
    
    try {
      button.textContent = 'Adding products...';
      button.disabled = true;

      const productsWithVariants = await this.getVariantIds(missingProducts);
      await this.addProductsToCart(productsWithVariants);
      
      // Refresh the cart drawer to show newly added items
      console.log('🔄 Refreshing cart drawer to show new items...');
      await this.refreshCartDrawer();
      
      // Wait longer for cart drawer to update, then recheck bundle
      setTimeout(() => {
        console.log('🔄 Rechecking bundle after adding products...');
        this.isProcessing = false;
        this.checkForBundleProducts();
      }, 2000); // Increased delay to 2 seconds
      
    } catch (error) {
      console.error('Error adding bundle products:', error);
      button.textContent = originalText;
      button.disabled = false;
      this.isProcessing = false;
      alert('Sorry, there was an error adding the products. Please try again.');
    }
  }

  async refreshCartDrawer() {
    try {
      console.log('🔄 Attempting to refresh cart drawer...');
      
      // Method 1: Trigger Shopify's built-in cart refresh events
      document.dispatchEvent(new CustomEvent('cart:updated'));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      
      // Method 2: Try theme-specific refresh methods
      if (window.theme && window.theme.cart && typeof window.theme.cart.refresh === 'function') {
        window.theme.cart.refresh();
        console.log('✅ Used theme.cart.refresh()');
      }
      
      // Method 3: Try Shopify's built-in cart drawer refresh
      if (window.CartDrawer && typeof window.CartDrawer.refresh === 'function') {
        window.CartDrawer.refresh();
        console.log('✅ Used CartDrawer.refresh()');
      }
      
      // Method 4: Fetch and update cart drawer section
      const response = await fetch('/?section_id=cart-drawer');
      if (response.ok) {
        const sectionHtml = await response.text();
        
        // Parse the response to get just the cart items
        const parser = new DOMParser();
        const doc = parser.parseFromString(sectionHtml, 'text/html');
        const newCartItems = doc.querySelector('#CartDrawer-CartItems .cart-items');
        const currentCartItems = document.querySelector('#CartDrawer-CartItems .cart-items');
        
        if (newCartItems && currentCartItems) {
          currentCartItems.innerHTML = newCartItems.innerHTML;
          console.log('✅ Updated cart items via section refresh');
        }
      }
      
      // Method 5: Force re-fetch cart data
      await this.fetchCartData();
      
    } catch (error) {
      console.error('Error refreshing cart drawer:', error);
    }
  }

  async getVariantIds(products) {
    const productsWithVariants = [];
    
    for (const product of products) {
      try {
        const response = await fetch(`/products/${product.handle}.js`);
        const productData = await response.json();
        
        if (productData.variants && productData.variants.length > 0) {
          productsWithVariants.push({
            ...product,
            variantId: productData.variants[0].id
          });
        }
      } catch (error) {
        console.error(`Error fetching variant for ${product.handle}:`, error);
      }
    }
    
    return productsWithVariants;
  }

  async addProductsToCart(products) {
    const items = products.map(product => ({
      id: product.variantId,
      quantity: 1
    }));

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items })
    });

    if (!response.ok) {
      throw new Error(`Failed to add products: ${response.status}`);
    }

    return await response.json();
  }

  async applyBundleDiscount() {
    try {
      console.log('🎯 APPLYING BUNDLE DISCOUNT...');
      console.log('Discount Code:', BUNDLE_CONFIG.discountCode);
      
      // Method 1: Try to apply discount directly using cart/update.js
      console.log('Trying Method 1: cart/update.js with discount parameter...');
      const response1 = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          discount: BUNDLE_CONFIG.discountCode
        })
      });
      
      console.log('Method 1 Response Status:', response1.status);
      if (response1.ok) {
        const result1 = await response1.json();
        console.log('Method 1 Result:', result1);
      }
      
      // Method 2: Try the discount URL approach
      console.log('Trying Method 2: discount URL...');
      try {
        const discountResponse = await fetch(`/discount/${BUNDLE_CONFIG.discountCode}`, {
          method: 'GET',
          redirect: 'manual'
        });
        console.log('Method 2 Response Status:', discountResponse.status);
      } catch (discountError) {
        console.log('Method 2 Error (expected):', discountError.message);
      }
      
      // Method 3: Store in cart attributes (for checkout)
      console.log('Trying Method 3: cart attributes...');
      const response3 = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: { 
            'discount_code': BUNDLE_CONFIG.discountCode,
            '_discount': BUNDLE_CONFIG.discountCode,
            'promo_code': BUNDLE_CONFIG.discountCode,
            'bundle_discount_applied': 'true'
          }
        })
      });
      
      console.log('Method 3 Response Status:', response3.status);
      if (response3.ok) {
        const result3 = await response3.json();
        console.log('Method 3 Result:', result3);
      }
      
      // Check final cart state
      await this.fetchCartData();
      console.log('Final cart after all methods:', this.cartData);
      
      console.log('✅ Discount application attempts completed');
      
      // Show success message
      this.showBundleComplete();
      
    } catch (error) {
      console.error('❌ Error applying discount:', error);
      this.showBundleComplete();
    }
  }

  showBundleComplete() {
    const discountAmount = Math.round(this.cartData.total_price * 0.15);
    const newTotal = this.cartData.total_price - discountAmount;
    
    const successHtml = `
      <div class="bundle-success" data-bundle-success>
        <div class="bundle-success__content">
          <h3>🎉 Bundle Complete!</h3>
          <p>Your ${BUNDLE_CONFIG.discountCode} discount will be applied at checkout!</p>
        </div>
      </div>
    `;
    
    const cartDrawer = this.findCartDrawer();
    if (cartDrawer) {
      const cartItems = cartDrawer.querySelector('.cart-items, [data-cart-items], .cart__items');
      if (cartItems) {
        cartItems.insertAdjacentHTML('afterend', successHtml);
      }
    }

    // Also intercept the main checkout button to add discount
    this.interceptCheckoutButtons();
  }

  interceptCheckoutButtons() {
    // Find and modify the main checkout button
    const checkoutButton = document.querySelector('#checkout, [href="/checkout"], [href*="checkout"], .checkout-button, [data-checkout]');
    
    if (checkoutButton) {
      console.log('🔗 Found checkout button, adding discount parameter');
      
      // Store original href if it's a link
      if (checkoutButton.tagName.toLowerCase() === 'a') {
        const originalHref = checkoutButton.href || '/checkout';
        const newHref = this.addDiscountToUrl(originalHref);
        checkoutButton.href = newHref;
        console.log('✅ Updated checkout link to:', newHref);
      } 
      // If it's a button, add click handler
      else {
        checkoutButton.addEventListener('click', (e) => {
          e.preventDefault();
          window.location.href = `/checkout?discount=${BUNDLE_CONFIG.discountCode}`;
          console.log('✅ Redirecting to checkout with discount');
        });
      }
    }
  }

  addDiscountToUrl(url) {
    try {
      const urlObj = new URL(url, window.location.origin);
      urlObj.searchParams.set('discount', BUNDLE_CONFIG.discountCode);
      return urlObj.toString();
    } catch (error) {
      // Fallback for relative URLs
      const separator = url.includes('?') ? '&' : '?';
      return `${url}${separator}discount=${encodeURIComponent(BUNDLE_CONFIG.discountCode)}`;
    }
  }
}

// CSS Styles - Using your latest updates
const bundleStyles = `
  .bundle-banner {
    background: #e7ebef82;
    border: 2px solid #92a5b6;
    border-radius: 12px;
    padding: 20px;
    margin: 15px 0;
    box-shadow: 0 4px 12px rgba(33, 150, 243, 0.15);
  }

  .bundle-banner__header {
    text-align: center;
    margin-bottom: 16px;
  }

  .bundle-banner__header h3 {
    margin: 0 0 12px 0;
    font-size: 18px;
    font-weight: 600;
    color: #123b60;
  }

  .bundle-banner__header p {
    margin: 0;
    font-size: 13px;
    line-height: 1.2em;
    color: #a4a4a8;
  }

  .bundle-banner__products {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 16px;
  }

  .bundle-missing-product {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px;
    background: white;
    border-radius: 6px;
    border: 1px solid #e0e0e0;
  }

  .bundle-missing-product img {
    width: 40px;
    height: 40px;
    object-fit: cover;
    border-radius: 4px;
  }

  .bundle-missing-product span {
    flex: 1;
    font-size: 13px;
    color: #333;
  }

  .bundle-missing-product .price {
    font-weight: bold;
    color: #9bb559;
    flex: none;
  }

  .bundle-banner__action {
    text-align: center;
    margin-bottom: 12px;
  }

  .bundle-complete-button {
    background: #c6e872;
    color: #123b60;
    border: none;
    padding: 14px 24px;
    border-radius: 8px;
    font-weight: bold;
    font-size: 14px;
    cursor: pointer;
    width: 100%;
    transition: all 0.3s ease;
  }

  .bundle-complete-button:hover {
    background: #c6e872;
    transform: translateY(-1px);
  }

  .bundle-complete-button:disabled {
    background: #ccc;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }

  .bundle-total {
    display: block;
    font-size: 12px;
    opacity: 0.9;
  }

  .bundle-banner__discount {
    text-align: center;
  }

  .bundle-banner__discount small {
    color: #ff5722;
    font-weight: bold;
    font-size: 14px;
  }

  .bundle-success {
    background: #92a5b6;
    color: white;
    border-radius: 12px;
    padding: 20px;
    margin: 15px 0;
    text-align: center;
    animation: fadeIn 0.5s ease;
  }

  .bundle-success__content h3 {
    margin: 0 0 8px 0;
    font-size: 18px;
  }

  .bundle-success__content p {
    margin: 0;
    opacity: 0.9;
    font-size: 14px;
  }

  .bundle-discount-summary {
    background: rgba(255,255,255,0.1);
    border-radius: 8px;
    padding: 16px;
    margin: 16px 0;
  }

  .discount-line {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
    font-size: 14px;
  }

  .bundle-savings {
    color: #fff;
    font-weight: bold;
  }

  .total-line {
    border-top: 2px solid rgba(255,255,255,0.3);
    padding-top: 8px;
    margin-top: 8px;
    font-size: 16px;
  }

  .proceed-to-checkout-btn {
    background: #e7ebef;
    color: #607c94;
    border: 0;
    padding: 14px 24px;
    border-radius: 8px;
    font-weight: bold;
    font-size: 16px;
    cursor: pointer;
    width: 100%;
    margin-top: 16px;
    transition: all 0.3s ease;
  }

  .proceed-to-checkout-btn:hover {
    background: white;
    color: #607c94;
  }

  .totals__discount-line {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 8px 0;
    padding: 8px 0;
    border-top: 1px solid #e0e0e0;
  }

  .totals__discount-label {
    color: #28a745;
    font-size: 16px;
    margin: 0;
    font-weight: bold;
  }

  .totals__discount-value {
    color: #28a745;
    font-size: 16px;
    margin: 0;
    font-weight: bold;
  }

  .totals__final {
    border-top: 2px solid #B5C2CE;
    padding-top: 12px;
    margin-top: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .totals__total-value--discounted {
    color: #113b605 !important;
    font-weight: bold !important;
    font-size: 18px !important;
  }

  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(-10px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;

// Inject styles
const styleSheet = document.createElement('style');
styleSheet.textContent = bundleStyles;
document.head.appendChild(styleSheet);

// Initialize when page loads
document.addEventListener('DOMContentLoaded', () => {
  console.log('Bundle Cart Drawer initialized');
  new BundleCartDrawer();
});